import { z } from "zod"

import { apiClient, assertOk } from "@/api/generated/client.ts"
import { dataPointSchema } from "@/types/dataPointSchemas.ts"
import type { DataPoint } from "@/types/dataPointTypes.ts"

export const getAllDataPoints = async (): Promise<DataPoint[]> => {
  const { data, error, response } = await apiClient.GET("/api/DataPoints")
  assertOk(response, error)
  return z.array(dataPointSchema).parse(data)
}
